export default "__VITE_ASSET__d65e3858__"